import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    borderTop: '1px solid gray',
    paddingTop: 30,
    paddingBottom: 10,
    marginTop: 20
  },
  saveButton: {
    marginLeft: 8
  },
  circularProgress: {
    marginLeft: 8,
    color: theme.palette.primary.main
  },
  redText: { color: theme.palette.primary.main, fontWeight: 500, fontSize: 16 },
  whiteText: {
    color: theme.palette.primary.contrastText,
    fontWeight: 500,
    fontSize: 16
  }
}))
export default useStyles
